import { AuthReactGAHandlers, CollegeReactGAHandlers, MarketingReactGAHandlers } from "../ReactGAHandlers"
import { URL } from "../dictionary"

const PurchaseButton = (props) => {

  const {
    user,
    priceID,
    groupAccessCode,
    clientSecret,
    setClientSecret,
    setUpgradeUserGroupAccessCode,
    premiumProductName,
    premiumContentPrice,
    page,
    clickLocation,
    activityID,
    setNavigateTo,
    setPrompt
  } = props;

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()
  const { handleGAEventPurchaseModalPurchase } = CollegeReactGAHandlers()
  const { handleGAEventPurchaseButtonClick,
    handleGAEventECInsightsPurchaseClick
  } = MarketingReactGAHandlers()

  const handlePurchaseButtonGAEvent = (page, clickLocation, activityID) => {
    switch (page) {
      case 'Specialized Rankings':
        return handleGAEventPurchaseButtonClick('Specialized Rankings', clickLocation)
      case 'RD Spend':
        return handleGAEventPurchaseButtonClick('RD Spend', clickLocation)
      case 'Crime':
        return handleGAEventPurchaseButtonClick('Crime', clickLocation)
      case 'EC Insights':
        return handleGAEventECInsightsPurchaseClick(activityID, clickLocation)
    }
  }

  const guest = (
    <div className="d-flex flex-column">
      <a
        className="dca-marketing-access-duration-purchase-button"
        data-bs-toggle={"modal"}
        href={"#login_modal"}
        onClick={() => {
          page != 'EC Insights' && setNavigateTo('');

          setPrompt('You must be signed in to access this feature. Please sign-in to your NextFour account (or sign-up for a free account) below:');
          handleGAEventSignInModalOpen('forced');
          handlePurchaseButtonGAEvent(page, clickLocation, activityID)
        }}
      ><span className="dca-marketing-access-duration-purchase-button-text">Purchase</span>
      </a>
      <div className="dca-marketing-access-duration-purchase-button-sign-in-text">Already purchased? <a
        className="dca-marketing-access-duration-purchase-button-sign-in-text-modal-trigger"
        data-bs-toggle="modal"
        href="#login_modal"
        onClick={(e) => {
          e.stopPropagation();
          handleGAEventSignInModalOpen('forced');
          handlePurchaseButtonGAEvent(page, clickLocation, activityID)
        }}>Sign In</a>
      </div>
    </div>
  )

  const auth = user?.validatedEmail ? (
    <button
      className='dca-marketing-access-duration-purchase-button'
      data-bs-target={`#add_payment_method_modal`}
      data-bs-toggle="modal"
      onClick={async () => {

        handlePurchaseButtonGAEvent(page, clickLocation, activityID);

        if (clientSecret != '') {
          await setClientSecret('')
        }

        await setUpgradeUserGroupAccessCode(groupAccessCode);

        handleGAEventPurchaseModalPurchase(premiumProductName);

        await fetch(`${URL}/create-checkout-session/${priceID}`, {
          method: "POST",
        }).then((res) => res.json())
          .then((data) => setClientSecret(data.clientSecret)).catch((error) => {
            console.error('Error:', error);
          });
      }}

    ><span className="dca-marketing-access-duration-purchase-button-text">Purchase</span></button>
  ) : (
    <button
      className='dca-marketing-access-duration-purchase-button'
      data-bs-target={`#email_verification_request_modal`}
      data-bs-toggle="modal"
      onClick={async () => {
        handlePurchaseButtonGAEvent(page, clickLocation, activityID);
      }}
    ><span className="dca-marketing-access-duration-purchase-button-text">Purchase</span></button>
  )

  return (
    <div className="dca-marketing-access-duration-and-purchase-button" style={{ marginTop: props.topMargin, marginBottom: props.bottomMargin }}>
      <div className="dca-marketing-access-duration-and-price-wrapper">
        <div className="dca-marketing-access-duration-text">{props.personalizedPage ? 'Q&A Per Topic' : '1 YEAR ACCESS'}</div>
        <div className="dca-marketing-access-duration-price">{premiumContentPrice ? `$${premiumContentPrice}` : 'N/A'}</div>
      </div>

      <div className="dca-marketing-access-duration-and-purchase-button-spacer"></div>

      {user ? auth : guest}
    </div>
  )
}

const PurchaseButtonNav = (props) => {
  const {
    user,
    priceID,
    groupAccessCode,
    clientSecret,
    setClientSecret,
    setUpgradeUserGroupAccessCode,
    premiumProductName,
    page,
    clickLocation,
    activityID,
    setNavigateTo,
    setPrompt
  } = props;

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()
  const { handleGAEventPurchaseModalPurchase } = CollegeReactGAHandlers()
  const {
    handleGAEventPurchaseButtonClick,
    handleGAEventECInsightsPurchaseClick
  } = MarketingReactGAHandlers()

  const handlePurchaseButtonGAEvent = (page, clickLocation, activityID) => {
    switch (page) {
      case 'Specialized Rankings':
        return handleGAEventPurchaseButtonClick('Specialized Rankings', clickLocation)
      case 'RD Spend':
        return handleGAEventPurchaseButtonClick('RD Spend', clickLocation)
      case 'Crime':
        return handleGAEventPurchaseButtonClick('Crime', clickLocation)
      case 'EC Insights':
        return handleGAEventECInsightsPurchaseClick(activityID, clickLocation)
    }
  }

  const guest = (
    <a
      className="dca-marketing-access-duration-purchase-button-nav"
      data-bs-toggle={"modal"}
      href={"#login_modal"}
      onClick={() => {
        page != 'EC Insights' && setNavigateTo('');

        setPrompt('You must be signed in to access this feature. Please sign-in to your NextFour account (or sign-up for a free account) below:');
        handleGAEventSignInModalOpen('forced');
        handlePurchaseButtonGAEvent(page, clickLocation, activityID)
      }}
    ><span className="dca-marketing-access-duration-purchase-button-nav-text">Purchase</span>
    </a>
  )

  const auth = user?.validatedEmail ? (
    <button
      className='dca-marketing-access-duration-purchase-button-nav'
      data-bs-target={`#add_payment_method_modal`}
      data-bs-toggle="modal"
      onClick={async () => {

        handlePurchaseButtonGAEvent(page, clickLocation, activityID);

        if (clientSecret != '') {
          await setClientSecret('')
        }

        await setUpgradeUserGroupAccessCode(groupAccessCode);

        handleGAEventPurchaseModalPurchase(premiumProductName);

        await fetch(`${URL}/create-checkout-session/${priceID}`, {
          method: "POST",
        }).then((res) => res.json())
          .then((data) => setClientSecret(data.clientSecret)).catch((error) => {
            console.error('Error:', error);
          });
      }}

    ><span className="dca-marketing-access-duration-purchase-button-nav-text">Purchase</span></button>
  ) : (
    <button
      className='dca-marketing-access-duration-purchase-button-nav'
      data-bs-target={`#email_verification_request_modal`}
      data-bs-toggle="modal"
      onClick={async () => {
        handlePurchaseButtonGAEvent(page, clickLocation, activityID);
      }}

    ><span className="dca-marketing-access-duration-purchase-button-nav-text">Purchase</span></button>
  )

  return (
    <div className="dca-marketing-access-duration-and-purchase-button-navbar">
      {user ? auth : guest}
    </div>
  )
}

const PurchaseButtonPersonalizedExpertHelp = (props) => {

  const {
    user,
    priceID,
    setPurchaseID,
    premiumContentPrice,
    setNavigateTo,
    prevPurchaseCount,
    latestPurchaseDate,
    setNoCostExpertHelpPurchase,
    setPrompt
  } = props;

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()

  const guest = (
    <div className="d-flex flex-column">
      <a
        className="dca-marketing-access-duration-purchase-button"
        data-bs-toggle={"modal"}
        href={"#login_modal"}
        onClick={() => {
          setNavigateTo('');
          setPrompt('You must be signed in to access this feature. Please sign-in to your NextFour account (or sign-up for a free account) below:');
          handleGAEventSignInModalOpen('forced');
        }}
      ><span className="dca-marketing-access-duration-purchase-button-text">Get Help</span>
      </a>
      <div className="dca-marketing-access-duration-purchase-button-sign-in-text">Already purchased? <a
        className="dca-marketing-access-duration-purchase-button-sign-in-text-modal-trigger"
        data-bs-toggle="modal"
        href="#login_modal"
        onClick={(e) => {
          e.stopPropagation();
          handleGAEventSignInModalOpen('forced');
        }}>Sign In</a>
      </div>
    </div>
  )

  const auth = user?.validatedEmail ? (
    <button
      className='dca-marketing-access-duration-purchase-button'
      data-bs-target="#purchase_modal"
      data-bs-toggle="modal"
      onClick={(e) => {
        e.stopPropagation();
        setPurchaseID(priceID);

        prevPurchaseCount === undefined && setNoCostExpertHelpPurchase(true)
      }}
    ><span className="dca-marketing-access-duration-purchase-button-text">{prevPurchaseCount != undefined ? 'Purchase' : 'Get Help'}</span></button>
  ) : (
    <button
      className='dca-marketing-access-duration-purchase-button'
      data-bs-target={`#email_verification_request_modal`}
      data-bs-toggle="modal"
    ><span className="dca-marketing-access-duration-purchase-button-text">{prevPurchaseCount != undefined ? 'Purchase' : 'Get Help'}</span></button>
  )

  return props.latestPurchaseDate != undefined ? (
    <div className="d-flex flex-column justify-content-center" style={{ maxWidth: 'min-content', marginTop: props.topMargin, marginBottom: props.bottomMargin }}>
      <div className="dca-marketing-access-duration-and-purchase-button"
      >
        <div className="dca-marketing-access-duration-and-price-wrapper">
          <div className="dca-marketing-access-duration-text" style={{ whiteSpace: 'nowrap' }}>{prevPurchaseCount != undefined ? `Expert Q&A Per Topic` : `Expert Q&A Feature`}</div>
          <div className="dca-marketing-access-duration-price">{premiumContentPrice !== undefined ? (
            prevPurchaseCount === undefined ? (
              <span>
                <span className="dca-strikethrough">$20</span> Free To Try!
              </span>
            ) : (
              `$${premiumContentPrice}`
            )
          ) : (
            'N/A'
          )}
          </div>
        </div>

        <div className="dca-marketing-access-duration-and-purchase-button-spacer"></div>

        {user ? auth : guest}
      </div>

      <div
        style={{
          marginTop: '20px',
          color: 'red',
          maxWidth: 'fit-content',
          textAlign: 'center'
        }}>{props.prevPurchaseCount > 1 ? `You purchased multiple instances of this feature, most recently on ${props.latestPurchaseDate}. Please refer to the instructions in the corresponding purchase confirmation email.` : `You requested a free trial for this feature on ${props.latestPurchaseDate} and received instructions in the corresponding purchase confirmation email.`} You may purchase another instance of this feature for additional personalized help.</div>

    </div>
  ) : (
    <div className="dca-marketing-access-duration-and-purchase-button" style={{ marginTop: props.topMargin, marginBottom: props.bottomMargin }}>
      <div className="dca-marketing-access-duration-and-price-wrapper">
        <div className="dca-marketing-access-duration-text">Expert Q&A Feature</div>
        <div className="dca-marketing-access-duration-price">{premiumContentPrice !== undefined ? (
          prevPurchaseCount === undefined ? (
            <span>
              <span className="dca-strikethrough">$20</span> Free To Try!
            </span>
          ) : (
            `$${premiumContentPrice}`
          )
        ) : (
          'N/A'
        )}
        </div>
      </div>

      <div className="dca-marketing-access-duration-and-purchase-button-spacer"></div>

      {user ? auth : guest}
    </div>
  )
}

const PurchaseButtonPersonalizedExpertHelpNav = (props) => {

  const {
    user,
    priceID,
    setPurchaseID,
    setNavigateTo,
    prevPurchaseCount,
    setNoCostExpertHelpPurchase,
    setPrompt
  } = props;

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()
  const { handleGAEventPurchaseModalPurchase } = CollegeReactGAHandlers()
  const {
    handleGAEventPurchaseButtonClick,
    handleGAEventECInsightsPurchaseClick
  } = MarketingReactGAHandlers()

  const guest = (
    <a
      className="dca-marketing-access-duration-purchase-button-nav"
      data-bs-toggle={"modal"}
      href={"#login_modal"}
      onClick={() => {
        setNavigateTo('');
        setPrompt('You must be signed in to access this feature. Please sign-in to your NextFour account (or sign-up for a free account) below:');
        handleGAEventSignInModalOpen('forced');
      }}
    ><span className="dca-marketing-access-duration-purchase-button-nav-text">Get Help</span>
    </a>
  )

  const auth = user?.validatedEmail ? (
    <button
      className='dca-marketing-access-duration-purchase-button-nav'
      data-bs-target="#purchase_modal"
      data-bs-toggle="modal"
      onClick={(e) => {
        e.stopPropagation();
        setPurchaseID(priceID);

        prevPurchaseCount === undefined && setNoCostExpertHelpPurchase(true)
      }}

    ><span className="dca-marketing-access-duration-purchase-button-nav-text">{prevPurchaseCount != undefined ? 'Purchase' : 'Get Help'}</span></button>
  ) : (
    <button
      className='dca-marketing-access-duration-purchase-button-nav'
      data-bs-target={`#email_verification_request_modal`}
      data-bs-toggle="modal"

    ><span className="dca-marketing-access-duration-purchase-button-nav-text">{prevPurchaseCount != undefined ? 'Purchase' : 'Get Help'}</span></button>
  )

  return (
    <div className="dca-marketing-access-duration-and-purchase-button-navbar">
      {user ? auth : guest}
    </div>
  )
}

export {
  PurchaseButton,
  PurchaseButtonNav,
  PurchaseButtonPersonalizedExpertHelp,
  PurchaseButtonPersonalizedExpertHelpNav
}